const SegmentCard = ({ title, imageURL, regURL, descURL, shortDesc, isOngoing }) => {
  const titleArr = title.split(' ');
  const first = titleArr.splice(0, 1);

  return (
    <div id="init" className="card flex flex-col relative">
      {isOngoing ? (
        <div className="absolute text-sm top-2 right-3 bg-orange-600 text-white px-3 py-1 rounded-md shadow-md">
          On Going!
        </div>
      ) : null}
      <img
        src={imageURL}
        alt={'Card Image'}
        className="card_banner aspect-square w-full h-full object-cover"
      />
      <div className="flex flex-1 flex-col justify-between h-full">
        <div className="p-5 pb-4 md:pb-6 flex flex-col justify-center gap-2 text-center">
          <h1 className="text-2xl gap-1 justify-center text-center">
            <span className="text-primary inline">{first}</span> {titleArr.join(' ')}
          </h1>
          <p className="line-clamp-4">{shortDesc}</p>
        </div>
        <div className="w-full flex place-items-center justify-center justify-self-end gap-4">
          <a
            className="relative flex items-center justify-center overflow-hidden  bg-primary shadow-2xl transition-all before:absolute before:h-0 before:w-0 before:rounded-full before:bg-primary_dark before:duration-500 before:ease-out hover:shadow-primary_dark hover:before:h-56 hover:before:w-56 learn_more text-white text-lg cursor-pointer"
            href={regURL}
          >
            <span className="relative z-10">Register</span>
          </a>
          <a
            className="relative flex items-center justify-center overflow-hidden bg-secondary_light text-primary_dark shadow-2xl transition-all before:absolute before:h-0 before:w-0 before:rounded-full before:bg-primary_dark before:duration-500 before:ease-out hover:shadow-primary_dark hover:before:h-56 hover:before:w-56 learn_more hover:text-white text-lg cursor-pointer"
            href={descURL}
          >
            <span className="relative z-10">Learn More</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default SegmentCard;
